/**
 * Ground telegraphs: warning shapes that commit after their lead time.
 * Zones deal damage at commit; lines are pure warnings for incoming volleys.
 * After commit, entries linger a few steps (negative `left`) for the flash.
 * Pixi-free — the renderer reads `list` each frame.
 */

const FLASH_STEPS = 6;

export interface Telegraph {
  shape: 'zone' | 'line';
  /** Render style tag (sim stays pixi-free — the color mapping lives in the
   *  renderer). 'debris' = ME4 falling-rubble zones, drawn as brown circles. */
  style: 'generic' | 'debris';
  x: number;
  y: number;
  radius: number;
  angle: number;
  length: number;
  width: number;
  left: number;
  total: number;
  damage: number;
}

export class TelegraphSystem {
  list: Telegraph[] = [];

  spawnZone(
    x: number, y: number, radius: number, leadSteps: number, damage: number,
    style: Telegraph['style'] = 'generic',
  ): void {
    this.list.push({
      shape: 'zone', style, x, y, radius, angle: 0, length: 0, width: 0,
      left: leadSteps, total: leadSteps, damage,
    });
  }

  spawnLine(x: number, y: number, angle: number, length: number, width: number, leadSteps: number): void {
    this.list.push({
      shape: 'line', style: 'generic', x, y, radius: 0, angle, length, width,
      left: leadSteps, total: leadSteps, damage: 0,
    });
  }

  /** onZoneCommit fires exactly once per zone, at its commit step. */
  update(onZoneCommit: (t: Telegraph) => void): void {
    for (let i = this.list.length - 1; i >= 0; i--) {
      const t = this.list[i]!;
      t.left--;
      if (t.left === 0 && t.shape === 'zone') onZoneCommit(t);
      if (t.left <= -FLASH_STEPS) {
        const last = this.list.length - 1;
        this.list[i] = this.list[last]!;
        this.list.pop();
      }
    }
  }

  clear(): void {
    this.list.length = 0;
  }
}
